<template>
  <div>
    <v-card flat :loading="loading" class="tab-details">
      <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
      <v-card-text>
        <div class="mx-12 text-h6 font-weight-black mt-3 text-c-green">
          {{ local.caseFile.tabHeaders.suspensions }}
        </div>
        <v-row class="mx-12">
          <template>
            <v-col v-for="(suspension, index) in suspensions" :key="index" cols="4">
              <suspension-card :suspension="suspension"></suspension-card>
            </v-col>
          </template>
          <v-col cols="12">
            <naj-no-data :has-data="suspensions && suspensions.length > 0" :loading="loading"></naj-no-data>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <degree-color-palette></degree-color-palette>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('CasesModule');
import { toHijriDate, getTimePart } from '@/helpers/utils';
import DegreeColorPalette from '../degree-color-palette';
import SuspensionCard from '@/modules/global/components/cards/suspension-card.vue';

export default {
  name: 'CaseSuspensionsTab',
  components: {
    DegreeColorPalette,
    SuspensionCard,
  },
  props: {
    caseObjectKey: {
      type: String,
      required: true,
    },
    isPega: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      suspensions: [],
      loading: false,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions(['getCaseSuspensions']),
    toHijriDate,
    getTimePart,
    loadData() {
      this.loading = true;
      this.getCaseSuspensions(this.caseObjectKey)
        .then((res) => {
          this.suspensions = res.data;
        })
        .finally(() => (this.loading = false));
    }
  },
};
</script>

<style scoped></style>
